import sileo from 'sileo';
import axios from 'source/lib/axios';
import plex from 'core/js/restmodel';

const ValidateUsername = new sileo.Model('hqzen', 'validate-username');
const JobPreferenceDetails = new sileo.Model('hqzen', 'job-preference-details');
const ApplicantProfileResource = new sileo.Model('hqzen', 'applicant-user-profile');
const EducationalBackground = new sileo.Model('hqzen', 'educational-backgrounds');
const ApplicantWorkExperiences = new sileo.Model('hqzen', 'work-experiences');
const AvatarAmazonFormData = new sileo.Model('hqzen', 'avatar-amazon-form-data');
const ResumeAmazonFormData = new sileo.Model('hqzen', 'resume-amazon-form-data');
const EmailChangeVerification = new sileo.Model('hqzen', 'email-change-verification');
const JobLocations = new sileo.Model('hqzen', 'job-locations');
const JobPositions = new sileo.Model('hqzen', 'job-positions');
const JobSpecialty = new sileo.Model('hqzen', 'job-specialty');
const JobFocus = new sileo.Model('hqzen', 'job-focus');
const Skills = new sileo.Model('hqzen', 'profile-skills');
const PhoneNumberChangeVerification = new sileo.Model('hqzen', 'phone-number-change-verification');
const JobApplicationResume = new sileo.Model('bposeats', 'job-application-document');
const UserProfiles = new sileo.Model('board', 'user-profiles');




const state = {
    applicantWorkExperience: {},
    educationalBackground: []
};

const mutations = {
    setToken(state, token) {
        if (token.token) {
            axios.defaults.headers.common['Authorization'] = token.token;
            sileo.defaults.headers['Authorization'] = token.token;
            plex.defaults.headers['Authorization'] = token.token;

            axios.defaults.headers.common['X-Refresh-Token'] = token.refresh;
            sileo.defaults.headers['X-Refresh-Token'] = token.refresh;
            plex.defaults.headers['X-Refresh-Token'] = token.refresh;
            localStorage.setItem('auth_token', token.token);
            localStorage.setItem('refresh_token', token.refresh);
        }
    },

    updateWorkExperiences(state, work_experiences) {
        state.applicantWorkExperience = work_experiences;
    },

    setEducationalBackground(state, educationalBackground) {
        state.educationalBackground = educationalBackground;
    },
};

const actions = {
    sendEmailChangeVerification(context, filters) {
        return EmailChangeVerification.objects.update(filters);
    },

    sendPhoneNumberChangeVerification(context, filters) {
        return PhoneNumberChangeVerification.objects.update(filters);
    },

    fetchEmailChangeVerification(context, filters) {
        const payload = {
            code: filters,
            token: localStorage.getItem('tfa_token')
        };
        return EmailChangeVerification.objects.filter(payload);
    },

    getJobPreferenceDetails(context, filters) {
        return JobPreferenceDetails.objects.filter(filters);
    },

    fetchApplicantResume(context, filters) {
        return JobApplicationResume.objects.filter(filters);
    },

    removeJobApplicationResume(context, filePk) {
        const form = new FormData();
        form.append('removed', true);
        return JobApplicationResume.objects.update({ 'pk': filePk }, form);
    },

    fetchProfileDetails(context, filters) {
        return ApplicantProfileResource.objects.filter(filters);
    },

    async fetchApplicantWorkExperiences({ commit }, pk) {
        await ApplicantWorkExperiences.objects.get(pk).then(response => {
            commit('updateWorkExperiences', response);
        });
    },

    updateWorkExperiences({ commit }, data) {
        const form = new FormData();
        form.append('work_experiences_bulk', JSON.stringify(data.work_experiences));
        form.append('years_of_experience', data.years_of_experience);
        return ApplicantWorkExperiences.objects.update({ 'user_profile_id': data.user_profile_id }, form)
            .then(response => {
                commit('updateWorkExperiences', response);
                return response;
            }).catch(response => {
                return response;
            });
    },

    updateProfileDetails({ commit }, data) {
        return ApplicantProfileResource.objects.update(data.filters, data.form)
        .then(response => {
            commit('setToken', { 'token': response.auth_tokens.new_access_token,
            'refresh': response.auth_tokens.new_refresh_token });


            if (localStorage.getItem('auth_token')) {
                sileo.defaults.headers['Authorization'] = localStorage.getItem('auth_token');
            }
            if (localStorage.getItem('refresh_token')) {
                sileo.defaults.headers['X-Refresh-Token'] = localStorage.getItem('refresh_token');
            }
            return response;
        }).catch(response => {
            return response;
        });
    },

    fetchResumeAmazonFormData(context) {
        return ResumeAmazonFormData.objects.filter().then(data => {
            return data.amazon;
        });
    },

    async fetchAvatarAmazonData(context) {
        return await AvatarAmazonFormData.objects.filter().then(amazon => {
            return amazon.amazon;
        });
    },
    fetchJobLocations(context, filters) {
        return JobLocations.objects.filter(filters);
    },

    fetchJobPositions(context, filters) {
        return JobPositions.objects.filter(filters);
    },

    fetchJobSpecialty(context, filters) {
        return JobSpecialty.objects.filter(filters);
    },

    fetchJobFocus(context, filters) {
        return JobFocus.objects.filter(filters);
    },

    fetchSkills(context, filters) {
        return Skills.objects.filter(filters);
    },

    updateJobPreference(context, data) {
        const form = new FormData();

        for (let key of Object.keys(data)) {
            if (key == 'user_profile_id') {
                continue;
            }
            let value = data[key];
            if (key == 'job_locations' ||
                key == 'job_focuses' ||
                key == 'job_positions' ||
                key == 'job_specialties') {
                    value = JSON.stringify(value);
            }
            form.append(key, value);
        }

        return JobPreferenceDetails.objects.update({
            'applicant__user_profile_id': data.user_profile_id
        }, form);
    },

    async fetchEducationalBackground({ commit }, pk) {
        await EducationalBackground.objects.get(pk).then(function (data) {
            commit('setEducationalBackground', data.educational_backgrounds);
        });
    },

    updateEducationalBackground({ commit }, obj) {
        const form = new FormData();
        form.append('educational_backgrounds_bulk', JSON.stringify(obj.educational_backgrounds));
        return EducationalBackground.objects.update({ 'user_profile_id': obj.user_profile_id }, form)
            .catch(response => {
                return response;
        });
    },

    validateUsernameDetails(context, filters) {
        return ValidateUsername.objects.filter(filters);
    },

    fetchUserProfileDetails(context, filters) {
        return UserProfiles.objects.filter(filters);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
